<template>
  <div style="height: calc(100vh - 120px)">
    <el-row :gutter="20" style="height: calc(100% - 20px)">
      <el-col :span="6" :xs="24" class="h-full">
        <el-card class="m-l-15 m-t-15 m-b-15 h-full">
          <el-form :model="form" label-width="70px" style="padding-bottom: 60px">
            <el-form-item label="活动名称:" prop="name" style="margin-bottom: 0">
              <div style="text-align: left" class="b-b h-30">{{ form.name }}</div>
            </el-form-item>
            <el-form-item label="开始时间:" prop="startTime" style="margin-bottom: 0">
              <div style="text-align: left" class="b-b h-30">{{ form.startTime }}</div>
            </el-form-item>
            <el-form-item label="结束时间:" prop="endTime" style="margin-bottom: 0">
              <div style="text-align: left" class="b-b h-30">{{ form.endTime }}</div>
            </el-form-item>
            <el-form-item label="卡券金额:" prop="packetPrice" style="margin-bottom: 0">
              <div style="text-align: left" class="b-b h-30">{{ form.packetPrice }}</div>
            </el-form-item>
            <el-form-item label="卡券数量:" prop="packetNum" style="margin-bottom: 0">
              <div style="text-align: left" class="b-b h-30">{{ form.packetNum }}</div>
            </el-form-item>
            <el-form-item label="满额限制:" prop="limitationPrice" style="margin-bottom: 0">
              <div style="text-align: left" class="b-b h-30">{{ form.limitationPrice }}</div>
            </el-form-item>
            <el-form-item label="活动状态:" prop="status" style="margin-bottom: 0">
              <div style="text-align: left" class="b-b h-30">{{ getActivityStatus(form.status) }}</div>
            </el-form-item>
            <el-form-item label="卡券状态:" prop="packetStatus" style="margin-bottom: 0">
              <div style="text-align: left" class="b-b h-30">{{ getPacketStatus(form) }}</div>
            </el-form-item>
            <el-form-item label="领券人数:" prop="extractCount" style="margin-bottom: 0">
              <div style="text-align: left" class="b-b h-30">{{ form.extractCount }}</div>
            </el-form-item>
            <el-form-item label="开启活动:" style="margin-bottom: 0">
              <el-button type="text" @click="onActivityStatusChange">{{
                  form.status !== 1 ? '开始' : '结束'
                }}
              </el-button>
            </el-form-item>
            <el-form-item label="开启领券:" style="margin-bottom: 0" v-if="form.status === 1">
              <el-button type="text" @click="onPacketStatusChange">{{
                  form.packetStatus !== 1 ? '开始' : '结束'
                }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
      <el-col :span="18" :xs="24" class="h-full">
        <el-card class="m-r-15 m-t-15 m-b-15 h-full">
          <el-tabs class="h-full o-y-auto" v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane :label="item.label" :name="item.id" :key="index" v-for="(item,index) in tabList">
              <component :is="getComponent(item.id)" :activityId="activityId" class="p-b-10"
                         v-if="activeName === item.id">
              </component>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import PacketRecordComponent from './component/packetRecordComponent'
import ActivityApi from '@/api/activity.js'
import bus from '@/utils/eventBus.js'

export default {
  name: 'detail',
  components: {PacketRecordComponent},
  data () {
    return {
      activityId: 0,
      activeName: '0',
      tabList: [
        {
          id: '0',
          label: '领取记录'
        }],
      form: {},
    }
  },
  created () {
    bus.$on('activityChange', res => {
      this.getActivityDetail()
    })
  },
  destroyed () {
    bus.$off('activityChange')
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.activityId = parseInt(this.$route.query.activityId || 0)
      this.getActivityDetail()
    },
    getComponent (tabIndex) {
      let componentName = ''
      let index = parseInt(this.activeName || 0)
      console.log('tabIndex=', tabIndex, 'index=', index)
      if (parseInt(tabIndex) === index) {
        switch (index) {
          case 0:
            componentName = 'PacketRecordComponent'
            break
        }
      }
      return componentName
    },
    getActivityDetail () {
      if (this.activityId) {
        ActivityApi.getActivityDetailById({activityId: this.activityId}, true).then(res => {
          this.form = res.data
        })
      }
    },
    getActivityStatus (status) {
      let text = ''
      if (status === 0) {
        text = '未开始'
      } else if (status === 1) {
        text = '进行中'
      } else if (status === 2) {
        text = '已结束'
      }
      return text
    },
    getPacketStatus (row) {
      let text = ''
      let status = row.status
      let packetStatus = row.packetStatus
      if (status === 0) {
        text = '未开始'
      } else if (status === 1) {
        if (packetStatus === 0) {
          text = '未开始'
        } else if (packetStatus === 1) {
          text = '进行中'
        } else if (packetStatus === 2) {
          text = '已结束'
        }
      } else if (status === 2) {
        text = '已结束'
      }

      return text
    },
    onPacketStatusChange () {
      ActivityApi.setPacketStatus({
        activityId: this.activityId
      }, true).then(res => {
        this.getActivityDetail()
      })
    },
    onActivityStatusChange () {
      ActivityApi.setActivityStatus({
        activityId: this.activityId
      }, true).then(res => {
        this.getActivityDetail()
      })
    },
    handleClick () {

    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/coupon/activity/detail.vue